import * as React from 'react';
import styles from './index.less';
import { Dispatch } from 'redux';
import {
  OnAdd_Policy_Action,
  OnMount_PolicyPage_Action,
  ResourceAuthPageModelState,
  UpdatePoliciesAction,
} from '@/models/resourceAuthPage';
import {
  Sider_OnChange_Page_Action,
  Sider_OnMount_Page_Action,
} from '@/models/collectionManager';
import * as AHooks from 'ahooks';
import { useParams } from 'umi';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FPolicyList from '@/components/FPolicyList';
import PolicyTemplates from '@/components/FPolicyTemplates';
import FIcons from '@/components/FIcons';

interface PolicyProps {
  dispatch: Dispatch;
  resourceAuthPage: ResourceAuthPageModelState;
}

function Policy({ dispatch, resourceAuthPage }: PolicyProps) {
  const params = useParams<{ id: string }>();
  AHooks.useMount(async () => {
    // console.log(params.id, 'params.id we8rfijohsdlkfjsdlfkjsdl');
    dispatch<Sider_OnMount_Page_Action>({
      type: 'collectionManager/sider_onMount_Page',
      payload: {
        resourceID: params.id!,
      },
    });
    dispatch<OnMount_PolicyPage_Action>({
      type: 'resourceAuthPage/onMount_PolicyPage',
      payload: {
        resourceID: params.id!,
      },
    });
    dispatch<Sider_OnChange_Page_Action>({
      type: 'collectionManager/sider_onChange_Page',
      payload: {
        page: 'policy',
      },
    });
  });

  return (
    <>
      <div className={styles.root}>
        <div style={{ height: 40 }} />
        <div className={styles.block}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.tAuto('authplanmgnt_title')}
              type={'highlight'}
            />
            {resourceAuthPage.policies.length > 0 && (
              <FComponentsLib.FTextBtn
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                }}
                type="primary"
                onClick={async () => {
                  // dispatch<OnClick_step3_addPolicyBtn_Action>({
                  //   type: 'resourceCreatorPage/onClick_step3_addPolicyBtn',
                  //   payload: {},
                  // });
                  dispatch<OnAdd_Policy_Action>({
                    type: 'resourceAuthPage/onAdd_Policy',
                    payload: {
                      trigger: 'collection',
                    },
                  });
                }}
              >
                <FIcons.FPolicy style={{ fontSize: 14 }} />
                <span>添加策略</span>
              </FComponentsLib.FTextBtn>
            )}
          </div>
          {resourceAuthPage.policies.length === 0 && (
            <>
              <div style={{ height: 10 }} />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FComponentsLib.FContentText
                  text={'资源需添加授权策略才能上架到资源市场，开放签约。'}
                  type={'additional2'}
                />
                <FComponentsLib.FContentText
                  text={
                    '授权策略，即资源对外授权范围和条件的申明，如支付10元获得一个月使用授权。'
                  }
                  type={'additional2'}
                />
                <div style={{ height: 20 }} />

                <FComponentsLib.FRectBtn
                  type={'primary'}
                  onClick={() => {
                    dispatch<OnAdd_Policy_Action>({
                      type: 'resourceAuthPage/onAdd_Policy',
                      payload: {
                        trigger: 'collection',
                      },
                    });
                  }}
                >
                  {FI18n.i18nNext.tAuto('authplanmgnt_list_empty_btn')}
                </FComponentsLib.FRectBtn>
              </div>
            </>
          )}

          {resourceAuthPage.policies.length > 0 && (
            <>
              <div style={{ height: 20 }} />
              <FPolicyList
                atLeastOneUsing={resourceAuthPage.status === 1}
                dataSource={resourceAuthPage.policies}
                onCheckChange={(data) => {
                  if (data.using) {
                    self._czc?.push([
                      '_trackEvent',
                      '授权信息页',
                      '上线',
                      '',
                      1,
                    ]);
                  }
                  dispatch<UpdatePoliciesAction>({
                    type: 'resourceAuthPage/updatePolicies',
                    payload: {
                      updatePolicies: [
                        {
                          policyId: data.id,
                          status: data.using ? 1 : 0,
                        },
                      ],
                    },
                  });
                }}
              />
            </>
          )}
        </div>

        <div style={{ height: 5 }} />

        <div className={styles.block}>
          <FComponentsLib.FContentText
            // text={'策略模板'}
            text={FI18n.i18nNext.tAuto('authplanmgnt_title_templates')}
            type={'highlight'}
          />
          <div style={{ height: 5 }} />
          <FComponentsLib.FContentText
            text={FI18n.i18nNext.tAuto('authplanmgnt_title_templates_help')}
            type={'additional2'}
          />
          <div style={{ height: 20 }} />
          <PolicyTemplates
            onSelect={(value) => {
              dispatch<OnAdd_Policy_Action>({
                type: 'resourceAuthPage/onAdd_Policy',
                payload: {
                  defaultValue: value,
                  trigger: 'collection',
                },
              });
            }}
          />
        </div>

        <div style={{ height: 100 }} />
      </div>
    </>
  );
}

export default connect(({ resourceAuthPage }: ConnectState) => ({
  resourceAuthPage: resourceAuthPage,
}))(Policy);
